import styled from "@emotion/styled";
import { differenceInSeconds } from "date-fns";
import { useEffect, useState } from "react";
import { getAddressFromCoords } from "../../api/geocoding";
import {
  BubbleTailIcon,
  MuteButton,
  //PhoneIcon,
  ReportIcon,
  ShowPwIcon,
  WarningModalIcon,
  XButton,
} from "../../assets/icons/icons";
import AlertModal from "../../components/alertModal";
import WriteReasonModal from "../../components/writeReasonModal";
import { DetectTodayResult, GetMobilityLive } from "../../types/types";
import useGetTripDistance from "../../hooks/useGetTripDistance";
import { DotLoader } from "../../components/dotLoader";
import { formatDate, handleKeyDown, maskPhoneNumber, textSubstring } from "../../utils/util";
import theme from "../../theme";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { useRecoilState } from "recoil";
import { accidentState } from "../../atoms/accident";
import { DeviceState } from "./DeviceState";
import { deviceImageArray } from "../../utils/deviceImageArray";
import { useI18n } from "../../locales";
//import { useGetLesseeDetail } from "../../hooks/useGetLessorDetail";

const { sm, md } = theme.screen;

const InfoContent: React.FC<{
  data: GetMobilityLive | DetectTodayResult;
  setWho: any;
  setOpenPhoneModal: any;
  showNum: any;
  showNokNum: any;
  openReportModal: any;
  setSelect: any;
  setSelectedInfo?: any;
  idx: number;
  setVisibleItems: React.Dispatch<
    React.SetStateAction<{
      item: string;
      phone: string;
    }>
  >;
}> = (props) => {
  const {
    data: el,
    setWho,
    setOpenPhoneModal,
    showNum,
    // showNokNum,
    openReportModal,
    setSelect,
    setSelectedInfo,
    setVisibleItems,
  } = props;
  const { t } = useI18n();
  // const isLease = process.env.REACT_APP_IS_LEASE ?? ""; // 임대프로그램이 포함됐는지 여부
  const [accident, setAccident] = useRecoilState(accidentState);
  const [openUnLockModal, setOpenUnLockModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [road, setRoad] = useState("");
  const [roadLoading, setroadLoading] = useState(false);
  const [activeMuteBtn, setActiveMuteBtn] = useState(false);
  const [timeDisplay, setTimeDisplay] = useState("");
  // const [openLessorPhoneAlert, setOpenLessorPhoneAlert] = useState(false);
  // const [showLessorPhone, setShowLessorPhone] = useState(false);

  const isLeased = !!el.lease_name; // 임차인 존재하는지 여부

  const { data: tripDistanceData, isLoading: tripDistanceDataIsLoading } =
    useGetTripDistance({
      mobility_seq: el?.seq,
    });

  // 임차인 정보 가져옴 (임대프로그램)
  // const { data: lesseeData, isPending: lesseeDataIsLoading } =
  //   useGetLesseeDetail({ device_pid: el.device_pid });

  const onClickUnLockBtn = () => {
    setOpenUnLockModal(true);
  };

  const onPressNo = () => {
    setOpenUnLockModal(false);
  };

  const onPressNo2 = () => {
    setOpenDetailModal(false);
  };

  const onPressYes = () => {
    setOpenDetailModal(true);
  };

  const getRoad = async () => {
    if (road) {
      // 다시 계산하지 않음
      return;
    } else {
      setroadLoading(true);
      try {
        const address = await getAddressFromCoords(el.latitude, el.longitude);
        setroadLoading(false);
        setRoad(address);
      } catch (error) {
        setroadLoading(false);
        setRoad(t.control.currentLocationError);
        return;
      }
    }
  };
  useEffect(() => {
    if (el) {
      getRoad();
    }
  }, [el]);

  const handleClick = () => {
    // 닫기 버튼
    setSelect("");
    setSelectedInfo(undefined);
  };

  // 사고 알림 뮤트 데이터에 추가
  const handleMute = () => {
    setAccident(null);
    setActiveMuteBtn(false);
    let muteData = localStorage.getItem("MUTE");
    if (!muteData) {
      localStorage.setItem(
        "MUTE",
        JSON.stringify([el.accident_header_seq])
      );
    }
    if (muteData) {
      let muteDataArr = JSON.parse(muteData);
      muteDataArr = [...muteDataArr, el.accident_header_seq];
      localStorage.setItem("MUTE", JSON.stringify(muteDataArr));
    }
  };

  // 사고 알림 뮤트 버튼이 활성화되는 조건
  useEffect(() => {
    let muteData = localStorage.getItem("MUTE");

    if (!el.accident_header_seq) {
      setActiveMuteBtn(false);
    }

    if (el.accident_header_seq) {
      // 사고발생했고, 로컬에 뮤트 데이터가 없는 경우
      if (!muteData) {
        setActiveMuteBtn(true);
        return;
      }
      // 사고 발생 했고, 로컬에 뮤트 데이터가 있는데 해당 사고가 뮤트된 경우
      let muteDataArr = JSON.parse(muteData);
      if (muteDataArr.includes(el.accident_header_seq)) {
        setActiveMuteBtn(false);
      } else {
        setActiveMuteBtn(true);
      }
    }
  }, [el, accident]);

  useEffect(() => {
    if (el) {
      setSelect(el.device_pid);
    }
  }, [el]);

  useEffect(() => {
    if (!("event_accident" in el)) return;

    const updateTimer = () => {
      const currentDate = new Date();
      const timeDifference = differenceInSeconds(
        currentDate,
        new Date(el.event_accident)
      );
      const minutes = Math.floor(timeDifference / 60);
      const seconds = timeDifference % 60;
      setTimeDisplay(t.control.accidentDetected(minutes, seconds));
    };

    const intervalId = setInterval(updateTimer, 1000);
    return () => clearInterval(intervalId);
  }, [el]);

  // console.log("idx : " + idx);
  // console.log(el);

  return (
    <Wrapper>
      {/* 사고 경과 시간 */}
      {el.accident_header_seq && (
        <AccidentDate>{timeDisplay}</AccidentDate>
      )}
      <XButtonContainer>
        {activeMuteBtn && (
          // 사고 알림 끄기 버튼
          <MuteButton
            onClick={handleMute}
            width={window.innerWidth <= theme.screen.md ? "20px" : "32px"}
            height={window.innerWidth <= theme.screen.md ? "20px" : "32px"}
          />
        )}
        {window.innerWidth <= theme.screen.md ? (
          <XButton width="25" height="25" onClick={handleClick} />
        ) : (
          <XButton onClick={handleClick} />
        )}
      </XButtonContainer>

      {/* 기기명[기기종류: 종류] 운행중/미운행*/}
      <Header>
        <CustomTooltip
          title={el?.mobility_name}
          active={el?.mobility_name?.length > 10}
        >
          <Mobility>
            {textSubstring(el.mobility_name, 0, 10, theme.screen.sm)}
          </Mobility>
        </CustomTooltip>
        <Id>{`[${t.control.deviceType}: ${el.mobility_type}]`}</Id>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <StatusCircle
            bgColor={
              el.status !== "운행중"
                ? theme.color.neutral_400
                : theme.color.green_500
            }
          />
          <span
            style={
              window.innerWidth > 451
                ? {
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "16px",
                    color: theme.color.neutral_600,
                  }
                : {
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    color: theme.color.neutral_600,
                  }
            }
          >
            {el.status}
          </span>
        </div>
      </Header>

      <ContentsSection>
        <FirstRow>
          {/* 기기 이미지 */}
          {el?.mobility_image === null ? (
            <CustomImg
              src={`${process.env.REACT_APP_BASE_URL}/img/${
                deviceImageArray.find(
                  (list) => list.device === el.mobility_type
                )?.popUpFileName
              }`}
              alt="농기계 이미지"
            />
          ) : (
            <CustomImg
              src={`${process.env.REACT_APP_BASE_URL}/${el?.mobility_image}`}
              alt="농기계 이미지"
            />
          )}

          <RightWrapper>
            <TextWrapper>
              <ThinText>{t.control.operationRecord}</ThinText>
              <ThickText>
                {(() => {
                  if (!el.min_registered_at && !el.max_registered_at) return t.control.noRecord;
                  if (!el.min_registered_at) return `(Last Operation : ${formatDate(el.max_registered_at, "HH:mm:ss")})`;
                  if (!el.max_registered_at) return formatDate(el.min_registered_at, "HH:mm:ss~");
                  const start = new Date(el.min_registered_at).getTime();
                  const end = new Date(el.max_registered_at).getTime();
                  const totalSeconds = Math.max(0, Math.floor((end - start) / 1000));
                  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
                  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
                  const s = String(totalSeconds % 60).padStart(2, '0');
                  return `${h}:${m}:${s}`;
                })()}
              </ThickText>
            </TextWrapper>
            <TextWrapper>
              <ThinText>{t.control.travelDistance}</ThinText>
              <ThickText>
                {tripDistanceDataIsLoading && <DotLoader />}
                {!tripDistanceDataIsLoading && tripDistanceData && (
                  <span>{tripDistanceData?.trip_distance + " km"}</span>
                )}
              </ThickText>
            </TextWrapper>

            {/* <TextWrapper>
              <ThinText>{t.control.currentLocation}</ThinText>
              <ThickText style={{ whiteSpace: "pre-wrap" }}>
                {roadLoading && <DotLoader />}
                {road}
              </ThickText>
            </TextWrapper> */}

            <TextWrapper>
              <ThinText>{t.control.farmMachineryVoltage}</ThinText>
              <ThickText>
                {el.board_input_volt ? el.board_input_volt + "V" : "0.0V"}
              </ThickText>
            </TextWrapper>

            {/* z 각도 */}
            <TextWrapper>
              <ThinText>{t.control.angle}</ThinText>
              <ThickText>
                {el.tilt_z ? `${el.tilt_z}${t.control.degreeUnit ?? ''}` : t.common.noData}
              </ThickText>
            </TextWrapper>

            {/* 현재상태 , 발생사고 */}
            <DeviceState events={el.events} />
          </RightWrapper>
        </FirstRow>
        <SecondRow>
          <SRLeft>
            {/* 소유자 정보 */}

            <CustomTooltip title={el?.name} active={el?.name?.length > 13}>
                <TextWrapper2>
                <SubText>{t.control.owner}</SubText>
                <MainText>
                  {textSubstring(
                    isLeased ? el.lease_name : el.name,
                    0,
                    13,
                    theme.screen.sm
                  )}
                </MainText>
              </TextWrapper2>
            </CustomTooltip>

            <TextWrapper2>
              <div
                onClick={() => {
                  if (!showNum) {
                    setVisibleItems({
                      item: t.control.ownerLabel,
                      phone: isLeased ? el.lease_phone : el.phone,
                    });
                    setWho(1);
                    setOpenPhoneModal(true);
                  } else return;
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: showNum ? "default" : "pointer",
                }}
                role="button"
                tabIndex={0}
                onKeyDown={handleKeyDown}
              >
                <SubText>{t.control.ownerContact}</SubText>
                {el.phone && !showNum && <ShowPwIcon />}
              </div>
              <MainText>
                {el.phone
                  ? showNum
                    ? isLeased
                      ? el.lease_phone
                      : el.phone
                    : isLeased
                      ? maskPhoneNumber(el.lease_phone)
                      : maskPhoneNumber(el.phone)
                  :""}
              </MainText>
            </TextWrapper2>
            {/* 임차인 정보  */}
            {/* {isLease && (
              <>
                <CustomTooltip
                  title={lesseeData?.result?.mbr_nm ?? ""}
                  active={
                    lesseeData?.result &&
                    lesseeData.result.mbr_nm.length > 13
                  }
                >
                  <TextWrapper2>
                    <SubText>임차인</SubText>
                    <MainText>
                      {lesseeDataIsLoading && <DotLoader />}
                      <span>
                        {lesseeData?.result &&
                          textSubstring(
                            lesseeData.result.mbr_nm,
                            0,
                            13,
                            theme.screen.sm
                          )}
                      </span>
                    </MainText>
                  </TextWrapper2>
                </CustomTooltip>

                <TextWrapper2>
                  <div
                    onClick={() => {
                      if (lesseeData?.result && !showLessorPhone) {
                        setOpenLessorPhoneAlert(true);
                      } else return;
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: lesseeData?.result ? "pointer" : "default",
                    }}
                  >
                    <SubText>임차인 연락처</SubText>
                    {lesseeData?.result && <ShowPwIcon />}
                  </div>
                  <MainText>
                    {lesseeDataIsLoading && <DotLoader />}
                    {lesseeData?.result && (
                      <span>
                        {showLessorPhone
                          ? `${lesseeData.result.phone}`
                          : "***-****-****"}
                      </span>
                    )}
                  </MainText>
                </TextWrapper2>
              </>
            )} */}
          </SRLeft>
          <SRRight>
            <CustomTooltip title={road} active={road?.length > 15}>
              <TextWrapper2>
                <SubText>{t.control.currentLocation}</SubText>
                <MainText isAdress={true}>
                  {roadLoading && <DotLoader />}
                  <span>
                    {textSubstring(road, 0, 15, theme.screen.sm)}
                  </span>
                </MainText>
              </TextWrapper2>
            </CustomTooltip>

            <TextWrapper2>
              <SubText>{t.control.rentalPurpose}</SubText>
              <MainText>{el.wt_type}</MainText>
            </TextWrapper2>

            {/* <CustomTooltip
              title={el?.nok_name}
              active={el?.nok_name?.length > 13}
            >
              <TextWrapper2>
                <SubText>추가 알림 수신자</SubText>
                <MainText>
                  {textSubstring(el.nok_name, 0, 13, theme.screen.sm)}
                </MainText>
              </TextWrapper2>
            </CustomTooltip> */}

            {/* <TextWrapper2>
              <div
                onClick={() => {
                  if (!showNokNum && el.nok_phone) {
                    setVisibleItems({
                      item: "추가 알림 수신자",
                      phone: el.nok_phone,
                    });
                    setWho(2);
                    setOpenPhoneModal(true);
                  } else return;
                }}
                style={
                  el.nok_phone
                    ? {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: showNokNum ? "default" : "pointer",
                      }
                    : {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }
                }
              >
                <SubText>추가 알림 수신자 연락처</SubText>
                {el.nok_phone && !showNokNum && <ShowPwIcon />}
              </div>
              <MainText>
                {el.nok_name != null
                  ? showNokNum
                    ? el.nok_phone
                    : maskPhoneNumber(el.nok_phone)
                  : ""}
              </MainText>
            </TextWrapper2> */}
            {/* <CustomTooltip
              title={el?.relation}
              active={el?.relation?.length > 13}
            >
              <TextWrapper2>
                <SubText>추가 알림 수신자와 소유자 관계</SubText>
                <MainText>
                  {textSubstring(el.relation, 0, 13, theme.screen.sm)}
                </MainText>
              </TextWrapper2>
            </CustomTooltip> */}
          </SRRight>
        </SecondRow>
      </ContentsSection>

      <BtnWrapper>
        <ReportBtn onClick={openReportModal}>
          <ReportIcon />
          <span>{t.control.farmMachineryUsageReport}</span>
        </ReportBtn>
        {el?.events?.includes("차량전복") && (
          <UnlockBtn onClick={onClickUnLockBtn}>
            {t.control.accidentDetectionRelease}
          </UnlockBtn>
        )}
      </BtnWrapper>
      {/* <FakeDiv /> */}

      {
        <BubbleContainer>
          <BubbleTailIcon />
        </BubbleContainer>
      }
      <AlertModal
        open={openUnLockModal}
        onPressNo={onPressNo}
        title={t.control.unlockRolloverStatus}
        content={t.control.unlockRolloverContent}
        confirmText={t.control.confirmUnlock}
        onPressYes={onPressYes}
        icon={<WarningModalIcon />}
      />
      {/* <AlertModal
        open={openLessorPhoneAlert}
        onPressNo={() => setOpenLessorPhoneAlert(false)}
        title={t.control.openContact}
        content={t.control.protectingPrivacy}
        content2={t.control.openLesseeContact}
        confirmText={t.control.openContactButton}
        onPressYes={() => {
          setShowLessorPhone(true);
          setOpenLessorPhoneAlert(false);
        }}
        icon={<PhoneIcon />}
      /> */}

      <WriteReasonModal
        open={openDetailModal}
        onPressNo={onPressNo2}
        title={t.control.accidentDetectionReleaseReason}
        data={el}
        content={t.control.accidentDetectionReleaseReasonDesc}
        icon={<WarningModalIcon />}
        confirmText={t.control.accidentDetectionReleaseButton}
        setSelect={setSelect}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 513px;
  padding-top: 50px;
  padding-left: 25px;
  padding-right: 25px;
  background: ${theme.color.white};
  border-radius: 20px;
  cursor: default;
  padding-bottom: 51px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;

  @media (max-width: ${sm}px) {
    width: 90vw;
    padding: 30px 20px;
    min-width: 320px;
  }

  @media (max-width: ${md}px) {
    width: 90vw;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: ${sm}px) {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
`;

const Mobility = styled.p`
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: ${theme.color.neutral_600};
  margin-right: 5px;

  @media (max-width: ${sm}px) {
    white-space: pre-wrap;
    font-size: 14px;
    /* margin-bottom: 5px; */
  }
`;

const Id = styled.strong`
  color: ${theme.color.neutral_500};
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  @media (max-width: ${sm}px) {
    font-size: 12px;
  }
`;

const FirstRow = styled.div`
  display: flex;
  gap: 25px;
  @media (max-width: ${sm}px) {
    gap: 20px;
  }
`;

export const SecondRow = styled.div`
  width: 463px;
  height: 248px;
  display: flex;
  background: ${theme.color.neutral_50};
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow-y: auto;

  @media (max-width: ${sm}px) {
    width: 100%;
    height: auto;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    width: 100%;
    padding: 15px;
  }
`;

export const RightWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: wrap;
`;

export const ThinText = styled.span`
  font-weight: 400;
  margin-right: 10px;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};

  @media (max-width: ${sm}px) {
    font-size: 12px;
    margin-right: 5px;
  }
`;

export const SRLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  border-right: 1px solid ${theme.color.neutral_200};
  width: 50%;
  @media (max-width: ${sm}px) {
    gap: 5px;
    padding-right: 10px;
  }
`;

export const SRRight = styled.div`
  display: flex;
  padding-left: 20px;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  width: 50%;

  @media (max-width: ${sm}px) {
    gap: 5px;
    padding-left: 10px;
  }
`;

export const TextWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SubText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
`;

export const MainText = styled.span<{ isAdress?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.color.neutral_600};
  min-height: 17px;
  white-space: normal; /* 텍스트 줄바꿈 가능 */
  overflow-wrap: break-word; /* 긴 단어 줄바꿈 */

  @media (max-width: ${sm}px) {
    min-height: ${({ isAdress }) => isAdress && "34px"};
    font-size: 10px;
    white-space: normal;
  }
  @media (max-width: ${md}px) {
    font-size: 12px;
  }
`;

export const ThickText = styled.div`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
  display: flex;
  align-items: center;

  @media (max-width: ${sm}px) {
    font-size: 12px;
  }
`;

export const TextWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;

  @media (max-width: ${sm}px) {
    margin-bottom: 5px;
  }
`;

const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 25px;
  justify-content: space-between;
  @media (max-width: ${sm}px) {
    gap: 15px;
  }
  @media (max-width: ${md}px) {
    margin-top: 10px;
  }
`;

const StatusCircle = styled.div<{ bgColor: string }>`
  width: 7px;
  height: 7px;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 50%;
  margin-left: 8px;
  margin-right: 8px;
  @media (max-width: ${sm}px) {
  }
`;

const ReportBtn = styled.button`
  width: 219px;
  height: 50px;
  background: ${theme.color.white};
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  color: ${theme.color.neutral_500};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  flex-grow: 1;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 1px 7px 1px rgba(0, 0, 0, 0.25);
  }
  margin-bottom: 5px;

  @media (max-width: ${sm}px) {
    width: 50%;
    height: 35px;
    font-size: 12px;
  }
`;

const UnlockBtn = styled.button`
  width: 219px;
  height: 50px;
  font-weight: 700;
  cursor: pointer;
  font-size: 15px;
  line-height: 24px;
  color: ${theme.color.white};
  background: ${theme.color.neutral_600};
  border-radius: 10px;
  border: none;
  flex-grow: 1;

  @media (max-width: ${sm}px) {
    width: 50%;
    height: 35px;
    font-size: 12px;
  }
`;

// const FakeDiv = styled.div`
//   width: 70px;
//   height: 70px;
//   background: ${theme.color.white};
//   position: absolute;
//   left: 50%;
//   transform: rotateZ(45deg) translateX(-50px);
//   bottom: -70px;
//   z-index: 1;

//   @media (max-width:  ${sm}px) {
//     z-index: -1;
//     left: 53%;
//     width: 40px;
//     height: 40px;
//     transform: rotateZ(45deg) translateX(-42px);
//     bottom: -50px;
//   }
// `;

const CustomImg = styled.img`
  width: 117px;
  height: 117px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid ${theme.color.neutral_300};

  @media (max-width: ${sm}px) {
    width: 70px;
    height: 70px;
  }
`;

const XButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  color: ${theme.color.neutral_400};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  @media (max-width: ${sm}px) {
    font-size: small;
    top: 7px;
    right: 7px;
  }
`;

const BubbleContainer = styled.div`
  position: absolute;
  bottom: -34px;
  right: 50%;
  transform: translateX(50%);
  z-index: 10;

  img {
    width: 50px;
  }
`;

const AccidentDate = styled.div`
  position: absolute;
  top: 15px;
  font-weight: bold;
  color: ${theme.color.red_500};

  @media (max-width: ${sm}px) {
    font-size: small;
    top: 10px;
  }
`;

const ContentsSection = styled.div`
  @media (max-width: ${sm}px) {
    max-height: 240px;
    overflow-y: scroll;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    max-height: 300px;
    overflow-y: scroll;
  }
`;

export default InfoContent;
